import { db } from "@repo/database";
import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import SettingsOrganizationPageTeam from "@/components/pages/admin/settings/orgId/members";
import { SubWrapper } from "@/components/generic/wrapper";
import { requireOrgMember } from "@/getAccess";
import { seo } from "@/seo";

const fetchMembersData = createServerFn({ method: "GET" })
	.validator((data: { orgId: string }) => data)
	.handler(async ({ data }) => {
		await requireOrgMember(data.orgId);
		const [invites, teams] = await Promise.all([
			db.query.invite.findMany({
				where: (invites, { eq, and }) => and(eq(invites.status, "pending"), eq(invites.organizationId, data.orgId)),
				with: {
					user: {},
				},
			}),
			db.query.team.findMany({
				where: (t, { eq }) => eq(t.organizationId, data.orgId),
			}),
		]);
		return { invites, teams };
	});

export const Route = createFileRoute("/(admin)/settings/org/$orgId/members/")({
	head: () => ({ meta: seo({ title: "Members · Settings" }) }),
	loader: async ({ params }) => {
		return await fetchMembersData({
			data: {
				orgId: params.orgId,
			},
		});
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { invites, teams } = Route.useLoaderData();

	return (
		<SubWrapper title="Team members" style="compact">
			<div className="flex flex-col gap-3">
				<SettingsOrganizationPageTeam invites={invites} teams={teams} />
			</div>
		</SubWrapper>
	);
}
